export const AlertTemplate = ({ style, options, message, close }) => {
    const alertStyle = {
        zIndex: 10000000,
        backgroundColor: options.type === 'success' ? "rgb(25, 135, 84)" : "#88110f",
        color: "whitesmoke",
        width: "300px",
        padding: "10px 20px 9px 20px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2em",
        fontFamily: "'Montserrat', sans-serif",
        fontSize: "1em",
        fontWeight: 600,
    }

    return (
        <div style={alertStyle} className="alert-container">
          <p style={{ margin: 0 }}>{message}</p>
        </div>
    )
}